@if (isAuthRoute()) {
  <app-auth-brand-panel />
}
<router-outlet></router-outlet>
<lib-toast></lib-toast>
